import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, MapPin, Bell, HelpCircle, Info, ChevronRight, LogOut, Plus } from 'lucide-react';
import { BottomNav } from './BottomNav';
interface AccountScreenProps {
  onTabChange: (tab: 'home' | 'activity' | 'account') => void;
}
export function AccountScreen({
  onTabChange
}: AccountScreenProps) {
  const menuItems = [{
    icon: CreditCard,
    label: 'Payment Methods'
  }, {
    icon: MapPin,
    label: 'Saved Places'
  }, {
    icon: Bell,
    label: 'Notifications'
  }, {
    icon: HelpCircle,
    label: 'Help & Support'
  }, {
    icon: Info,
    label: 'About'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="flex h-full flex-col bg-slate-50" data-id="element-1">
      <div className="flex-1 px-6 pb-24" data-id="element-2">
        {/* Header */}
        <header className="mb-8 mt-4 flex items-center justify-between" data-id="element-3">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-4">Account</h1>
          <button className="text-sm font-medium text-blue-600" data-id="element-5">Edit</button>
        </header>

        {/* Profile */}
        <div className="mb-8 flex items-center gap-4" data-id="element-6">
          <div className="h-20 w-20 overflow-hidden rounded-full border-4 border-white shadow-sm" data-id="element-7">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Profile" className="h-full w-full object-cover" data-id="element-8" />
          </div>
          <div data-id="element-9">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-10">Alex Johnson</h2>
            <p className="text-sm text-slate-500" data-id="element-11">+254 712 345 678</p>
          </div>
        </div>

        {/* Wallet Card */}
        <div className="mb-8 overflow-hidden rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 p-6 text-white shadow-lg shadow-blue-200" data-id="element-12">
          <div className="mb-6 flex items-start justify-between" data-id="element-13">
            <div data-id="element-14">
              <p className="mb-1 text-sm font-medium text-blue-100" data-id="element-15">
                MiniPay Balance
              </p>
              <h3 className="text-3xl font-bold" data-id="element-16">
                125.50{' '}
                <span className="text-lg font-normal text-blue-200" data-id="element-17">cUSD</span>
              </h3>
            </div>
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm" data-id="element-18">
              <CreditCard className="h-4 w-4 text-white" data-id="element-19" />
            </div>
          </div>
          <button className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold text-blue-600 transition-transform active:scale-95" data-id="element-20">
            <Plus className="h-4 w-4" data-id="element-21" />
            Add Funds
          </button>
        </div>

        {/* Menu */}
        <div className="mb-8 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-100" data-id="element-22">
          {menuItems.map((item, index) => <button key={item.label} className={`flex w-full items-center justify-between p-4 transition-colors hover:bg-slate-50 ${index !== menuItems.length - 1 ? 'border-b border-slate-50' : ''}`} data-id="element-23">
              <div className="flex items-center gap-3" data-id="element-24">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-50 text-slate-600" data-id="element-25">
                  <item.icon className="h-4 w-4" data-id="element-26" />
                </div>
                <span className="font-medium text-slate-900" data-id="element-27">{item.label}</span>
              </div>
              <ChevronRight className="h-4 w-4 text-slate-300" data-id="element-28" />
            </button>)}
        </div>

        {/* Sign Out */}
        <button className="flex w-full items-center justify-center gap-2 rounded-xl border border-red-100 bg-white py-3 font-medium text-red-600 transition-colors hover:bg-red-50" data-id="element-29">
          <LogOut className="h-4 w-4" data-id="element-30" />
          Sign Out
        </button>
      </div>

      <BottomNav activeTab="account" onTabChange={onTabChange} data-id="element-31" />
    </motion.div>;
}